import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';

type Props = {
  hasUnsavedChanges: boolean;
};

export default function UnsavedChangesInfoIcon({ hasUnsavedChanges }: Props) {
  if (!hasUnsavedChanges) {
    return null;
  }

  return (
    <Tooltip title="You have unsaved changes">
      <Box
        component="span"
        aria-label="Unsaved changes"
        role="img"
        sx={{
          color: 'warning.main',
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: 0,
        }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
}
